import { render, staticRenderFns } from "./ComfyStyleEdit.vue?vue&type=template&id=2bf30bc0&scoped=true"
import script from "./ComfyStyleEdit.vue?vue&type=script&lang=js"
export * from "./ComfyStyleEdit.vue?vue&type=script&lang=js"
import style0 from "./ComfyStyleEdit.vue?vue&type=style&index=0&id=2bf30bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf30bc0",
  null
  
)

export default component.exports